<template>
  <div class="picbox">
    <div class="title1">
      <span class="box-name">康复工作</span>
      <router-link to="/Column?menuid=30&text=康复工作" tag="a" class="more">更多</router-link>
    </div>
    <dl class="box">
      <dt class="img">
        <img src="../../../assets/img/kangfu.png" style="width: 100%;height: 100%;" alt="">
      </dt>
      <dd>
        <a href="javascript:;" @click="goArticle(item.id)" class="text" v-for="item in newsList" :key="item.id">{{item.title}}</a>

      </dd>
    </dl>
  </div>
</template>

<script>
  export default {
    name: 'picbox1',
    components: {},
    data() {
      return {
        newsList: []
      };
    },
    mounted() {
      this.findPageList()
    },
    methods: {
      goArticle(articleId) {
        let {
          href
        } = this.$router.resolve({
          path: "/Article", // 这里写的是要跳转的路由地址
          query: {
            articleId: articleId,
            menutext: '康复工作'
          } // 这里写的是页面参数
        });
        window.open(href, '_blank');
      },
      findPageList() {
        var that = this;
        that.$myHttp.post("findPageList?type=30313233343536&pageSize=5").then(function(data) {
          console.log(data)
          if (data.status == "200") {
            that.newsList = data.data.page.list;
          } else {
            alert("数据请求错误")
          }

        }).catch(function(error) {
          alert(error)
        })
      }
    }
  };
</script>

<style scoped>
  .picbox {
    height: 200px;
    width: 320px;
  }

  .title1 {
    height: 36px;
    line-height: 36px;
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #199352;
  }

  .title1 .box-name {
    font-size: 14px;
    color: #fff;
    background: #199352;
    font-weight: bold;
    padding: 0 10px;
  }

  .title1 .more {
    color: #515151;
    font-size: 12px;
    padding-right: 15px;
    background: url(../../../assets/img/1.png) no-repeat right center;
  }

  .news-list li a {
    font-size: 14px;
    line-height: 26px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #666;
  }

  .box {
    display: flex;
    justify-content: space-between;
  }

  .box .img {
    width: 100px;
    height: 136px;
    margin-top: 10px;
    padding: 3px;
    border: 1px solid #cdcdcd;
  }

  /* .box img:hover {
    width: 100px;
    height: 136px;
    margin-top: 10px;
    padding: 3px;
    border: 1px solid #cdcdcd;
  } */

  .box dd {
    width: 200px;
    padding-top: 5px;
  }

  .box dd .text {
    display: block;
    font-size: 15px;
    line-height: 28px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333;
    width: 100%;
    padding-left: 10px;
    background: url(../../../assets/img/dot.jpg) left center no-repeat;
  }

  .box dd .text:hover {
    color: #65A31E;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/views/front/components/picbox1.vue